import React from 'react'
import { Form } from 'antd'

import { manageToast } from '../../../components/Common/ManageToast'
import { serverlessApi } from '../../../utils/API'

import InternalKeyModal from './Modal'

const initialValues = {
  propertyId: undefined,
  unitId: undefined,
  internalKeyName: undefined,
  code: undefined,
  status: undefined,
  internalKeyType: undefined,
  keyType: 'keysProperty'
}

function InternalKeyCreateModal (props) {
  const { onClose, open, triggerCollectionRefetch } = props

  const [form] = Form.useForm()

  const [loading, setLoading] = React.useState(false)
  const [selectedProperty, setSelectedProperty] = React.useState(undefined)

  const handleClose = () => {
    form.resetFields()
    setSelectedProperty(undefined)
    onClose()
  }

  const handleInternalKeyCreate = values => {
    return Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        const {
          keyType,
          city,
          propertyId,
          unitId,
          ...restFields
        } = values

        const payload = { ...restFields }

        if (keyType === 'keysProperty') {
          payload.propertyId = propertyId
          payload.unitId = unitId
        } else {
          payload.city = city
        }

        return serverlessApi.createInternalKey(payload).then(res => {
          triggerCollectionRefetch()
          setLoading(false)
          manageToast(true, res.data.message)
          handleClose()
        })
      })
      .catch(() => setLoading(false))
  }

  return (
    <InternalKeyModal
      form={form}
      formName="internal-key-create"
      handleClose={handleClose}
      handleSubmit={handleInternalKeyCreate}
      open={open}
      initialValues={initialValues}
      submitButtonLabel="Create"
      loading={loading}
      selectedProperty={selectedProperty}
      setSelectedProperty={setSelectedProperty}
      title="Add New Internal Key"
    />
  )
}

export default InternalKeyCreateModal
